import request from "@/api/request";
//核销兑换码
export const conversion_cancel = (param) => {
  return request(`/web-h5/charge/conversion/cancel`, param, "POST");
};
//兑换码列表
export const conversion_list = (param) => {
  return request(`/web-h5/charge/conversion/list`, param, "POST");
};
